import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./vuex/store";

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.config.productionTip = false;

// import "./assets/adminlte/css/adminlte.min.css";
import "./assets/adminlte/css/adminlte.css";
import "./assets/adminlte/fontawesome-free/css/all.css";
import "./assets/nly-adminlte-vue/nly-adminlte-vue.css";
import "./assets/font/font.css";
import "./assets/nly-adminlte-vue/icon/iconfont.css";

import { NlyAdminlteVue, NlyAdminlteVueIcons } from "./nly-adminlte-vue";
Vue.use(NlyAdminlteVue);
Vue.use(NlyAdminlteVueIcons);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
